import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

const siteUrl = 'https://hanmanwu.com';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫屋',
  url: siteUrl,
  description: '韩漫屋提供海量免费正版韩国漫画在线阅读，每日更新热门韩漫，涵盖恋爱、校园、奇幻等多种题材。',
  sameAs: ['https://weibo.com/hanmanwu', 'https://space.bilibili.com/hanmanwu'],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫屋',
  url: siteUrl,
  potentialAction: {
    '@type': 'SearchAction',
    'target': `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: '韩漫屋上的漫画都是免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的！韩漫屋上的所有漫画均面向用户免费提供在线阅读。我们与多家韩国漫画平台和作者合作，通过正版授权方式为广大漫迷提供优质的阅读体验。' } },
    { '@type': 'Question', name: '韩漫屋的漫画多久更新一次？', acceptedAnswer: { '@type': 'Answer', text: '韩漫屋与韩国漫画平台保持同步更新。热门连载作品通常每周更新1-2话，具体更新频率取决于原作者的更新节奏。' } },
    { '@type': 'Question', name: '支持哪些设备阅读？', acceptedAnswer: { '@type': 'Answer', text: '韩漫屋采用响应式设计，完美支持PC端、平板和手机端的在线阅读。' } },
    { '@type': 'Question', name: '韩漫屋上的漫画是正版吗？', acceptedAnswer: { '@type': 'Answer', text: '韩漫屋严格遵守版权法规，平台上的所有漫画均通过正规渠道获得作者或版权方的授权。' } },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="韩漫屋 - 免费韩漫大全 | 海量正版韩国漫画在线阅读平台"
        description="韩漫屋提供海量免费正版韩国漫画在线阅读，每日更新热门韩漫，涵盖恋爱、校园、奇幻等多种题材，为您带来优质的韩漫阅读体验。韩漫屋 - 您的专属韩漫阅读平台。"
        keywords="韩漫屋,免费韩漫,正版韩漫,韩国漫画,在线阅读,热门韩漫,恋爱漫画,校园漫画,奇幻漫画"
        canonicalUrl={siteUrl}
        ogImage="https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20website%20homepage%20preview%2C%20warm%20peach%20gradient%2C%20collection%20of%20manga%20covers%2C%20clean%20minimal%20design%2C%20professional%20layout&width=1200&height=630&seq=og-homepage&orientation=landscape"
      />

      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <main>
        <Navbar />
        <div className="pt-0">
          <h1 className="sr-only">韩漫屋 - 免费韩漫大全，海量正版韩国漫画在线阅读平台</h1>
          <HeroSection />
          <CategorySection />
          <FeaturedSection />
          <LatestUpdates />
          <FAQSection />
        </div>
        <Footer />
      </main>
    </>
  );
}